import { getToken } from '@services/api';
import { useMutation } from '@tanstack/react-query';

export interface UseDownloadFileProps {
  baseUrl?: string;
  path: string;
}

/**
 * Download a file using a url generated by the api.
 * @param param0 Hook props, `baseUrl` and `path`.
 * @returns A mutation object.
 */
export const useDownloadFile = ({
  baseUrl = process.env.REACT_APP_PRODUCT_INVENTORY_SERVICE_BASE_URL,
  path,
}: UseDownloadFileProps) => {
  const mutate = useMutation(async () => {
    const token = await getToken();
    // Get a presigned url to download the file.
    const res = await fetch(`${baseUrl}${path}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error('Failed to get presigned url');
    }

    const body = await res.json();

    // Download the file using the provided url.
    window.open(body.payload.url, '_blank');
  });

  return mutate;
};
